import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useStore } from "../context/StoreContext";

export function ProductCard({ product, index = 0 }) {
  const { toggleWishlist, inWishlist } = useStore();
  const saved = inWishlist(product.id);
  const second = product.images?.[1] || product.images?.[0];
  return (
    <div className="group relative" data-testid={`product-card-${product.slug}`}>
      <Link to={`/product/${product.slug}`} className="block">
        <div className="relative aspect-[4/5] overflow-hidden bg-[#EDE6DA]">
          <img src={product.images?.[0]} alt={product.name} loading="lazy"
            className="absolute inset-0 h-full w-full object-contain object-bottom group-hover:opacity-0 transition-opacity duration-500" />
          <img src={second} alt="" aria-hidden loading="lazy"
            className="absolute inset-0 h-full w-full object-contain object-bottom opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
          {product.badge && (
            <span className="absolute left-4 top-4 bg-bone/90 backdrop-blur px-3 py-1 overline text-[10px] text-charcoal">{product.badge}</span>
          )}
        </div>
      </Link>
      <button
        onClick={() => toggleWishlist(product)}
        data-testid={`wishlist-toggle-${product.slug}`}
        aria-label="Add to wishlist"
        className="absolute right-3 top-3 h-9 w-9 flex items-center justify-center bg-bone/80 backdrop-blur transition-colors hover:bg-bone"
      >
        <Heart size={16} strokeWidth={1.4} className={saved ? "fill-gold text-gold" : "text-charcoal"} />
      </button>
      <div className="mt-4 flex items-start justify-between gap-3">
        <div>
          <p className="overline text-[10px] text-muted-foreground mb-1">{product.collection}</p>
          <Link to={`/product/${product.slug}`}>
            <h3 className="font-serif text-xl leading-tight">{product.name}</h3>
          </Link>
          <div className="mt-2 flex gap-1.5">
            {product.colors?.slice(0, 4).map((c) => (
              <span key={c.name} title={c.name} className="h-3 w-3 rounded-full border border-black/10" style={{ background: c.hex }} />
            ))}
          </div>
        </div>
        <div className="text-right font-display text-sm">
          {product.compare_at && <span className="block text-muted-foreground line-through text-xs">${product.compare_at}</span>}
          <span>${product.price}</span>
        </div>
      </div>
    </div>
  );
}
